import { useTranslations } from 'next-intl';
import { FilterSectionTitle } from '../FilterSectionTitle/FilterSectionTitle';
import { RangeSlider } from '../RangeSlider/RangeSlider';

type VolatilityFilterProps = {
  value: (string | undefined)[];
  onValueChange: (value: { min: string; max: string }) => void;
  namespace: string;
};
function VolatilityFilter({ value, onValueChange, namespace }: VolatilityFilterProps) {
  const t = useTranslations(namespace);
  const labels = [t('values.low'), t('values.mid'), t('values.high'), t('values.extreme')];
  const valueNumbers = [labels.indexOf(value[0] || t('values.low')) + 1, labels.indexOf(value[1] || t('values.extreme')) + 1];

  const handleValueChange = (value: { min: number; max: number }) => {
    onValueChange({ min: labels[value.min - 1]!, max: labels[value.max - 1]! });
  };

  return (
    <div data-track-container="Volatility" data-testid="volatility-filter">
      <FilterSectionTitle title={t('title')} tooltipContent={t('tooltip')} data-track-name="info" />
      <RangeSlider
        value={valueNumbers}
        onValueChange={handleValueChange}
        labels={labels}
        data-track-name="Volatility Slider"
        data-track-volatility-range={`${labels[valueNumbers[0]! - 1]}-${labels[valueNumbers[1]! - 1]}`}
      />
    </div>
  );
}

export { VolatilityFilter };
